import React from 'react';
import { Textarea } from 'components/UI/V3/Forms/Textarea/Textarea';
import styles from '../LeaveReview.module.scss';

export interface FeedbackTextareaProps {
    rating: number;
    value: string;
    onChange: (text: string) => void;
    required?: boolean;
    showRequiredAsterisk?: boolean;
    invalid?: boolean;
    helperText?: string;
}

const negativePlaceholders: Record<number, string> = {
    1: 'Sorry we didn’t meet expectations. Can you please share what went wrong?',
    2: 'Sorry we didn’t meet expectations. Can you please share what went wrong?',
    3: 'Thanks for sharing. How can we do better next time?'
};

const positivePlaceholder = 'Thanks for sharing. What did you love about your experience?';

const FeedbackTextarea: React.FC<FeedbackTextareaProps> = ({
    rating,
    value,
    onChange,
    required,
    showRequiredAsterisk,
    invalid,
    helperText
}) => {
    const placeholder =
        rating <= 3 ? negativePlaceholders[rating as 1 | 2 | 3] : rating >= 4 ? positivePlaceholder : '';
    return (
        <div className={styles.feedbackFieldWrapper}>
            {showRequiredAsterisk && (
                <div className={styles.feedbackLabel}>
                    <span>Comment</span>
                    {required && <span className={styles.requiredAsterisk}>*</span>}
                </div>
            )}
            <Textarea
                rows={5}
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
                aria-required={required || undefined}
                aria-invalid={invalid || undefined}
                className={invalid ? styles.invalidTextarea : undefined}
            />
            {helperText && <div className={styles.feedbackHelperError}>{helperText}</div>}
        </div>
    );
};

export default FeedbackTextarea;
